import { ThemeProvider } from '@ori-ui/mui';
import { StandaloneTokenProvider } from '@ori/auth';
import { getLogger, LogLevel } from '@ori/checkout-utils';
import { getConfiguration } from '@ori/subscription-wizard-lib';
import { createRoot } from 'react-dom/client';

import { App } from './App';
import { APP_NAME, EMOTION_CACHE_KEY } from './constants';
import { ErrorBoundary } from './containers/ErrorBoundary';

/**
 * React app renderer that is used when app is used as a standalone app
 */
export async function render(rootElement: HTMLElement) {
  const { config = '' } = rootElement.dataset;
  const clientAppConfig = getConfiguration(config);
  const { customerId, identityUrl } = clientAppConfig;
  const logDebug = getLogger(APP_NAME, LogLevel.Debug);

  if (!identityUrl) {
    throw new Error('Missing Identity URL!');
  }

  // Get token for local development
  if (process.env.NODE_ENV !== 'production') {
    // when using Requestly we do not want to load token
    if (process.env.REACT_APP_USE_REQUESTLY === '1') {
      logDebug('USING REQUESTLY :)');
    } else {
      // using msw for local dev
      const { worker } = await import('./mocks/browser');
      await worker.start();
      logDebug('USING MSW :)');
    }
  }

  createRoot(rootElement).render(
    <ErrorBoundary>
      <StandaloneTokenProvider customerId={customerId}>
        <ThemeProvider
          enableCacheProvider
          cacheKey={EMOTION_CACHE_KEY}
        >
          <App {...clientAppConfig} />
        </ThemeProvider>
      </StandaloneTokenProvider>
    </ErrorBoundary>,
  );
}
